if (!customElements.get('card-quantity-selector')) {
  customElements.define(
    'card-quantity-selector',
    class CardQuantitySelector extends HTMLElement {
      constructor() {
        super();
        this.variantId = this.dataset.variantId;
        this.form = this.querySelector('product-form');
        this.addButton = this.querySelector('.card-quantity-selector__add');
        this.stepper = this.querySelector('.card-quantity-selector__stepper');
        this.valueEl = this.querySelector('.card-quantity-selector__value');
        this.minusButton = this.querySelector('.card-quantity-selector__minus');
        this.plusButton = this.querySelector('.card-quantity-selector__plus');
        this.minusIcon = this.querySelector('.card-quantity-selector__minus-icon');
        this.trashIcon = this.querySelector('.card-quantity-selector__trash-icon');
        this.quantity = 0;
        this.requestInFlight = false;

        this.plusButton?.addEventListener('click', this.onPlusClick.bind(this));
        this.minusButton?.addEventListener('click', this.onMinusClick.bind(this));
      }

      connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.onCartUpdate.bind(this));
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
      }

      onCartUpdate(event) {
        const data = event?.cartData;
        if (!data) return;
        const eventVariantId = String(data.variant_id || data.id || '');
        if (eventVariantId !== String(this.variantId)) return;
        if (event.source === 'card-quantity-selector' && event.variantId !== this.variantId) return;
        const quantity = typeof data.quantity === 'number' ? data.quantity : this.quantity + 1;
        this.showAdded(quantity);
      }

      showAdded(quantity) {
        this.quantity = quantity;
        this.form?.classList.add('hidden');
        this.stepper?.classList.remove('hidden');
        this.updateDisplay();
      }

      showEmpty() {
        this.quantity = 0;
        this.stepper?.classList.add('hidden');
        this.form?.classList.remove('hidden');
      }

      updateDisplay() {
        if (this.valueEl) this.valueEl.textContent = this.quantity;
        const isOne = this.quantity <= 1;
        this.minusIcon?.classList.toggle('hidden', isOne);
        this.trashIcon?.classList.toggle('hidden', !isOne);
      }

      onPlusClick(event) {
        event.preventDefault();
        this.changeQuantity(this.quantity + 1);
      }

      onMinusClick(event) {
        event.preventDefault();
        this.changeQuantity(this.quantity - 1);
      }

      changeQuantity(newQuantity) {
        if (this.requestInFlight) return;
        this.requestInFlight = true;
        this.plusButton?.setAttribute('disabled', 'disabled');
        this.minusButton?.setAttribute('disabled', 'disabled');

        const body = JSON.stringify({
          id: this.variantId,
          quantity: newQuantity,
          sections: this.getSectionsToRender().map((section) => section.section),
          sections_url: window.location.pathname,
        });

        fetch(window.routes.cart_change_url, { ...fetchConfig(), ...{ body } })
          .then((response) => response.json())
          .then((parsedState) => {
            if (parsedState.errors) throw new Error(parsedState.errors);
            this.renderSections(parsedState);
            if (newQuantity <= 0) {
              this.showEmpty();
            } else {
              this.showAdded(newQuantity);
            }
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'card-quantity-selector',
              variantId: this.variantId,
              cartData: parsedState,
            });
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.requestInFlight = false;
            this.plusButton?.removeAttribute('disabled');
            this.minusButton?.removeAttribute('disabled');
          });
      }

      getSectionsToRender() {
        return [
          { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
          { id: 'CartDrawer', selector: '.drawer__inner', section: 'cart-drawer' },
        ];
      }

      renderSections(parsedState) {
        this.getSectionsToRender().forEach((section) => {
          const sectionElement = document.getElementById(section.id);
          if (!sectionElement || !parsedState.sections || !parsedState.sections[section.section]) return;
          const elementToReplace = sectionElement.querySelector(section.selector) || sectionElement;
          const html = new DOMParser().parseFromString(parsedState.sections[section.section], 'text/html');
          const newContent = html.querySelector(section.selector) || html.body.firstElementChild;
          if (elementToReplace && newContent) elementToReplace.innerHTML = newContent.innerHTML;
        });
      }
    }
  );
}
